// extracted by mini-css-extract-plugin
export default {"pageLink":"P_c1"};